export default "__VITE_ASSET__KIHoLlDn__"